import React from 'react'
import { Button as MuiButton, makeStyles, withStyles } from "@material-ui/core";
import { red } from '@material-ui/core/colors';


const useStyles = makeStyles(theme => ({
    root: {
        margin: theme.spacing(0.5)
    },
}))
const ColorButton = withStyles((theme) => ({
    root: {
        color: theme.palette.getContrastText(red[500]),
        backgroundColor: red[500],
        '&:hover': {
            backgroundColor: red[700],
        },
    },
}))(MuiButton);
export default function ButtonDanger(props) {

    const { text, size, color, variant, onClick, ...other } = props
    const classes = useStyles();

    return (
        <ColorButton
            variant={variant || "contained"}
            size={size || "large"}
            color={color || "primary"}
            onClick={onClick}
            {...other}
            classes={{ root: classes.root, label: classes.label }}>
            {text}
        </ColorButton>
    )
}
